const CartInitialState = {
    people: null,
    product: null,
    selectedDate: null,
    selectedRate: null,
    selectdTime: null,
    priceList: null,
    date: null,
    cartSession: null,

};
export default CartInitialState;